import { authApi } from '@shared/api/base/auth-base';
import {
    RegisterResponse,
    RegisterUserRequestData,
    SendVerifyEmailRequestData,
    SendVerifyEmailResponseData,
    VerifyEmailRequestData,
    VerifyEmailResponse,
} from './register-types';
import { API_PATH_REGISTRATION, API_SEND_VERIFICATION_EMAIL } from '@shared/config/api/api-paths';

export const registerApi = authApi.injectEndpoints({
    endpoints: (build) => ({
        register: build.mutation<RegisterResponse, RegisterUserRequestData>({
            query(body) {
                return {
                    url: API_PATH_REGISTRATION,
                    method: 'POST',
                    body,
                };
            },
            invalidatesTags: [],
        }),
        sendVerifyEmail: build.mutation<SendVerifyEmailResponseData, SendVerifyEmailRequestData>({
            query(body) {
                return {
                    url: API_SEND_VERIFICATION_EMAIL,
                    method: 'POST',
                    body,
                };
            },
        }),
        verifyEmail: build.mutation<VerifyEmailResponse, VerifyEmailRequestData>({
            query(body) {
                return {
                    url: '/email-verification',
                    method: 'POST',
                    body,
                };
            },
        }),
    }),
});

export const { useRegisterMutation, useVerifyEmailMutation, useSendVerifyEmailMutation } = registerApi;
